<div class="page">
  <header class="page-header">
    <div>
      <h1>PM AI</h1>
      <p class="muted">Heuristic by default — works without an OpenAI key.</p>
    </div>
  </header>

  @if (error()) {
    <div class="error-banner">{{ error() }}</div>
  }

  <div class="controls">
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [ngModel]="selectedProjectId" (ngModelChange)="selectProject($event)">
        @for (p of projects(); track p.id) {
          <mat-option [value]="p.id">{{ p.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Action</mat-label>
      <mat-select [(ngModel)]="activeAction">
        @for (a of actions; track a.id) {
          <mat-option [value]="a.id">{{ a.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (needsIssue()) {
      <mat-form-field appearance="outline">
        <mat-label>Issue</mat-label>
        <mat-select [(ngModel)]="selectedIssueId">
          @for (i of issues(); track i.id) {
            <mat-option [value]="i.id">{{ i.key }} — {{ i.summary }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (needsSprint()) {
      <mat-form-field appearance="outline">
        <mat-label>Sprint</mat-label>
        <mat-select [(ngModel)]="selectedSprintId">
          @for (s of sprints(); track s.id) {
            <mat-option [value]="s.id">{{ s.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (needsVersion()) {
      <mat-form-field appearance="outline">
        <mat-label>Version</mat-label>
        <mat-select [(ngModel)]="selectedVersionId">
          @for (v of versions(); track v.id) {
            <mat-option [value]="v.id">{{ v.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (needsPrompt()) {
      <mat-form-field appearance="outline" class="grow">
        <mat-label>Prompt / brief</mat-label>
        <textarea matInput rows="2" [(ngModel)]="prompt"></textarea>
      </mat-form-field>
    }

    <button mat-raised-button color="primary" [disabled]="loading()" (click)="run()">
      <mat-icon>auto_awesome</mat-icon> Run
    </button>
  </div>

  @if (loading()) {
    <div class="loading"><mat-spinner diameter="36"></mat-spinner></div>
  }

  @if (result(); as r) {
    <section class="result">
      <div class="result-meta">
        <span>{{ r.kindLabel }}</span>
        <span>· {{ r.provider }}</span>
        @if (r.confidence != null) { <span>· confidence {{ r.confidence | number:'1.0-2' }}</span> }
        @if (r.appliedAt) { <span class="applied">· applied</span> }
        <span class="spacer"></span>
        @if (r.id && !r.appliedAt) {
          <button mat-stroked-button color="primary" (click)="apply()" [disabled]="loading()">
            <mat-icon>check</mat-icon> Apply
          </button>
        }
      </div>

      @if (parsed(); as view) {
        <div class="result-body">
          @if (view.title) {
            <h2 class="result-title">{{ view.title }}</h2>
          }

          @if (view.stats.length) {
            <div class="stat-grid">
              @for (s of view.stats; track s.label) {
                <div class="stat-card">
                  <span class="stat-label">{{ s.label }}</span>
                  <span class="stat-value">{{ s.value }}</span>
                </div>
              }
            </div>
          }

          @if (view.drafts.length) {
            <div class="draft-list">
              <h3>Suggested tasks</h3>
              @for (d of view.drafts; track $index) {
                <article class="draft-card">
                  <div class="draft-summary">{{ d.summary }}</div>
                  <div class="draft-tags">
                    <span class="tag">{{ d.typeLabel }}</span>
                    <span class="tag" [ngClass]="d.priorityClass">{{ d.priorityLabel }}</span>
                  </div>
                </article>
              }
            </div>
          }

          @for (sec of view.sections; track sec.title) {
            <div class="section">
              <h3>{{ sec.title }}</h3>
              <ul>
                @for (item of sec.items; track $index) {
                  <li>{{ item }}</li>
                }
              </ul>
            </div>
          }

          @for (p of view.paragraphs; track $index) {
            <p class="paragraph">{{ p }}</p>
          }

          @if (view.markdown) {
            <div class="markdown" [innerHTML]="view.markdown"></div>
          }

          @if (view.rawFallback) {
            <pre class="raw-fallback">{{ view.rawFallback }}</pre>
          }
        </div>
      }
    </section>
  }
</div>
